module.exports = __webpack_public_path__ + "ec09cb6d58959fd7d9198806c1b96fe3.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GU.svg
// module id = KHw9
// module chunks = 0